export default (state, getters, rootState) =>  {
    return state.video.filter(i => {
        return i.path === rootState.route.fullPath;
    });
}